module.exports = __webpack_public_path__ + "img/base_divers_taxi.be4b8663.svg";